// Mocks for /api/secure/me/payments/* and /api/secure/me/packs/*
// (B6 backend territory — frontend mocks today, real cutover after B6.)

import { delay } from './index'

const STORAGE_KEY = 'patientPortal.mock.shop.v1'

function readStore() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
  } catch (e) {
    return {}
  }
}
function writeStore(s) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(s))
  } catch (e) {
    /* ignore */
  }
}

function seedFor(profile) {
  if (!profile) return { dues: [], packs: [], subscription: null }
  const isSelf = profile.relation === 'SELF'
  const dues = isSelf
    ? [
        {
          id: 'due_1',
          description: 'Therapy block — 4 sessions with Dr. Meera Iyer',
          amountMinor: 350000,
          currency: 'INR',
          createdAt: new Date(Date.now() - 2 * 86400000).toISOString(),
          dueLabel: 'Pay to unlock next 4 sessions',
        },
      ]
    : []
  const packs = isSelf
    ? [
        {
          packId: 'pack_meera_8',
          practitionerId: 'prac_dr_meera',
          practitionerName: 'Dr. Meera Iyer',
          name: '8-session therapy pack',
          sessionsUsed: 5,
          sessionsTotal: 8,
          expiryLabel: 'Valid until Jul 15',
          purchasedAt: new Date(Date.now() - 60 * 86400000).toISOString(),
        },
      ]
    : []
  const subscription = isSelf
    ? {
        tier: 'Free',
        renewsAt: null,
        upgradeOptions: [
          {
            tierId: 'pro',
            name: 'Pro',
            priceLabel: '₹499 / month',
            features: [
              'Unlimited messages with practitioner',
              'Detailed progress reports',
              'Priority support',
            ],
          },
        ],
      }
    : { tier: 'Free', renewsAt: null, upgradeOptions: [] }
  return { dues, packs, subscription }
}

function ensure(profile) {
  const store = readStore()
  if (!store[profile.id]) {
    store[profile.id] = seedFor(profile)
    writeStore(store)
  }
  return { store, prof: store[profile.id] }
}

export async function listDues(profile) {
  await delay()
  if (!profile) return []
  const { prof } = ensure(profile)
  return prof.dues
}

export async function payDue(profile, dueId) {
  await delay(350)
  if (!profile) return null
  const { store, prof } = ensure(profile)
  prof.dues = prof.dues.filter((d) => d.id !== dueId)
  store[profile.id] = prof
  writeStore(store)
  return { ok: true }
}

export async function listPacks(profile) {
  await delay()
  if (!profile) return []
  const { prof } = ensure(profile)
  return prof.packs
}

export async function getSubscription(profile) {
  await delay()
  if (!profile) return null
  const { prof } = ensure(profile)
  return prof.subscription
}

export async function upgradeSubscription(profile, tierId) {
  await delay(350)
  if (!profile) return null
  const { store, prof } = ensure(profile)
  prof.subscription = {
    tier: tierId.charAt(0).toUpperCase() + tierId.slice(1),
    renewsAt: new Date(Date.now() + 30 * 86400000).toISOString(),
    upgradeOptions: [],
  }
  store[profile.id] = prof
  writeStore(store)
  return prof.subscription
}

export function __resetShopMock() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    /* ignore */
  }
}
